/** Custom line icons (DESIGN: no emoji, no icon fonts). Replace with the provided sprite when it arrives. */
const base = {
  viewBox: '0 0 24 24',
  width: 24,
  height: 24,
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export const Icon = {
  garage: (
    <svg {...base}>
      <path d="M3 10.5 12 4l9 6.5V20H3z" />
      <path d="M7 20v-6h10v6M7 17h10" />
    </svg>
  ),
  tasks: (
    <svg {...base}>
      <path d="M9 6h11M9 12h11M9 18h11" />
      <path d="m3.5 6 1.5 1.5L7.5 5M3.5 12l1.5 1.5 2.5-2.5M3.5 18l1.5 1.5 2.5-2.5" />
    </svg>
  ),
  wheelTab: (
    <svg {...base}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 3.5v17M3.5 12h17M6 6l12 12M18 6 6 18" strokeWidth={1.2} />
      <circle cx="12" cy="12" r="2" fill="currentColor" />
    </svg>
  ),
  support: (
    <svg {...base}>
      <path d="M4.5 6.5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H10l-4.5 3.5v-3.5h0a1 1 0 0 1-1-1z" />
      <path d="M8.5 9.5h7M8.5 12.5h4.5" />
    </svg>
  ),
  vip: (
    <svg {...base}>
      <path d="M6 4h12l3 5-9 11L3 9z" />
      <path d="M3 9h18M9 4l3 16 3-16" />
    </svg>
  ),
  rank: (
    <svg {...base}>
      <path d="M4 20V13h4v7M10 20V8h4v12M16 20v-4h4v4" />
    </svg>
  ),
  ticket: (
    <svg {...base}>
      <path d="M3 8a2 2 0 0 0 0 4v0a2 2 0 0 1 0 4v2h18v-2a2 2 0 0 1 0-4v0a2 2 0 0 0 0-4V6H3z" />
      <path d="M15 6v12" strokeDasharray="1.5 2" />
    </svg>
  ),
  chevron: (
    <svg {...base} width={18} height={18}>
      <path d="m9 6 6 6-6 6" />
    </svg>
  ),
  medal: (place: number) => (
    <svg viewBox="0 0 24 24" width={22} height={22} aria-hidden>
      <circle
        cx="12"
        cy="12"
        r="9"
        fill={place === 1 ? 'oklch(0.82 0.12 85)' : place === 2 ? '#c9c6bd' : 'oklch(0.62 0.09 55)'}
      />
      <text
        x="12"
        y="16"
        textAnchor="middle"
        fontSize="11"
        fontWeight="700"
        fill="#141210"
        fontFamily="var(--font-sans)"
      >
        {place}
      </text>
    </svg>
  ),
  lock: (
    <svg {...base} width={40} height={40} strokeWidth={1.2}>
      <rect x="5" y="10.5" width="14" height="10" rx="2" />
      <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5M12 14.5v2.5" />
    </svg>
  ),
  wheel: (
    <svg {...base} width={40} height={40} strokeWidth={1.2}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="2" />
      <path d="M12 3v7M12 14v7M3 12h7M14 12h7M5.6 5.6l5 5M13.4 13.4l5 5M18.4 5.6l-5 5M10.6 13.4l-5 5" />
    </svg>
  ),
};
